module.exports = __webpack_public_path__ + "static/environment-hero-mobile.375fd841.webp";